import type { DashboardsResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetDashboardsQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetDashboardsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

export const useGetDashboards = createQueryHook<
  Record<string, never>,
  DashboardsResponseRow[],
  GetDashboardsQuery
>({
  trpcQueryOptions: (trpc) => trpc.frontend.dashboard.dashboards.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({
    dashboard: data,
  }),
  graphqlDocument: GetDashboardsDocument,
  // DashboardSelector + OverallDashboard co-mount and both read dashboards;
  // the factory default `no-cache` defeats Apollo dedup and the resulting
  // console.warn is promoted to FATAL in packages/web vitest. cache-first
  // lets the two consumers share one in-flight request.
  graphqlFetchPolicy: 'cache-first',
});
